/* global Swiper */

export default{
  init() {
    // Global host an event hero
    const globalHostEventHero = $('.global-host-event-hero');
    if (globalHostEventHero.length) {
      const swiperContainer = globalHostEventHero.find('.swiper-container').get(0);

      if (swiperContainer) {
        const autoplaySpeed = $(swiperContainer).data('autoplay-speed');
        let autoplay = false;

        if (autoplaySpeed) {
          autoplay = {
            delay: autoplaySpeed,
          };
        }

        new Swiper(swiperContainer, {
          autoplay,
          loop: true,
          effect: 'fade',
          slidesPerView: 1,
          fadeEffect: {
            crossFade: true,
          },
        });
      }
    }
  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalHostEventPage.js